<script setup lang="ts">
import type { Breadcrumb } from '@pkg/types/surpriseBag';
defineProps<{
  breadcrumbs: Breadcrumb[];
}>();

const emit = defineEmits(['onClick']);

</script>

<template>
  <nav aria-label="Breadcrumb">
    <ul class="breadcrumb">
      <li v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb__element">
        <NuxtLink @click="emit('onClick')" v-if="!crumb.isLast" :to="crumb.path" class="breadcrumb__link">{{ crumb.name }}</NuxtLink>
        <span v-else aria-current="page">{{ crumb.name }}</span>
      </li>
    </ul>
  </nav>
</template>

<style scoped>

.breadcrumb {
  display: flex;
  gap: 8px;
  list-style: none;
  padding: 0;
  color: theme('colors.neutral.70');

  &__element {
    &:last-child {
      flex: 1 3;
    }
  }

  &__link {
    flex: 2 3;
    text-decoration: none;
    color: var(--theme-heading-color-app);
    font-weight: bold;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
    &::after {
      content: "›";
      margin-left: 8px;
    }
  }
}
</style>
